import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { formatErr, http } from "../../lib/api";

const field =
  "w-full border-b border-white/15 bg-transparent py-3 text-base text-white placeholder:text-slate-500 outline-none transition-colors focus:border-[#E11D48]";

export const EnquiryForm = ({ product, onDone }) => {
  const initial = { name: "", phone: "", email: "", message: product ? `Is the ${product.title} still available and will it fit my car? Reg: ` : "" };
  const [f, setF] = useState(initial);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/enquiries", { ...f, product_id: product?.id, product_title: product?.title });
      toast.success("Enquiry sent", { description: "We'll get back to you shortly." });
      setF(initial);
      onDone?.();
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="space-y-5">
      <input required data-testid="enquiry-name-input" placeholder="Your name" value={f.name} onChange={set("name")} className={field} />
      <div className="grid gap-5 sm:grid-cols-2">
        <input data-testid="enquiry-phone-input" placeholder="Phone" value={f.phone} onChange={set("phone")} className={field} />
        <input type="email" data-testid="enquiry-email-input" placeholder="Email" value={f.email} onChange={set("email")} className={field} />
      </div>
      <textarea required rows={4} data-testid="enquiry-message-input" placeholder="Make, model, year, reg or part number..." value={f.message} onChange={set("message")} className={`${field} resize-none`} />
      <button
        type="submit"
        disabled={busy}
        data-testid="enquiry-submit-button"
        className="group flex h-12 items-center gap-3 rounded-full bg-white px-6 font-semibold text-[#090D12] transition-transform hover:scale-[1.03] active:scale-95 disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4 transition-transform group-hover:translate-x-1" />}
        Send enquiry
      </button>
    </form>
  );
};
